import React, { Component } from 'react';
import { Flex, Box } from 'grid-styled';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Map, List, fromJS } from 'immutable';
import qs from 'qs';

import History from '../history';
import connect from '../store/connect';
import Page from './Page';
import Cart from '../components/Cart';
import { Container } from '../styles/Container';
import { Heading } from '../styles/Heading';
import { Preamble } from '../styles/Preamble';
import { NavigationButton } from '../components/NavigationButton';
import { size, color } from '../styles/helpers/variables';
import LinedHeading from '../components/LinedHeading';
import { Paragraph } from '../styles/Paragraph';
import { InnerContainer, WhiteContainer } from './OrderConfirmationPage';
import DeliveryRow from '../components/DeliveryRow';
import CartWrapperCheckoutPage from '../components/CartWrapperCheckoutPage';
import { getTotalCartItems } from '../util/getTotalCartItems';
import { initializePayment, setDeliveryMethod, finalizePayment } from '../api/checkoutApi';
import AvardaCheckoutForm from '../components/AvardaCheckoutForm';
import { removeViewstate, fetchArticlePageView, fetchDeliveryMethods, fetchCart } from '../actions/actionCreators';
import { analyticsPurchaseEvent, analyticsCheckoutEvent } from '../util/analyticEvents';
import { Conditional } from "../components/Conditional";
import { LoadingSpinner } from '../components/LoadingSpinner';
import { CART_API_BASE_URL, SITE_ROOT_URL } from "../constants/endpoints";
import { CampaignCodeInput } from "../components/CampaignCodeInput";
import { PENDING, COMPLETE } from "../constants/status";

class CheckoutPage extends Component {
  constructor(props) {
    super(props);

    this.queryStringObject = qs.parse(window.location.search.substring(1));

    this.state = {
      avardaSessionId: null,
      deliveryMethodId: null,
      showAvardaError: false,
      serverSideCallbackUrl: null,
    };

    this.selectDeliveryMethodHandler = this.selectDeliveryMethodHandler.bind(this);
    this.completeFirstStep = this.completeFirstStep.bind(this);
    this.firstStep = this.firstStep.bind(this);
  }

  componentDidMount() {
    this.props.removeViewstate('cartActive');
    this.props.fetchDeliveryMethods();
    this.props.fetchArticlePageView({ urlPath: this.props.location.pathname });
    analyticsCheckoutEvent("checkoutStep2", 2, this.props.cart.get('cart', List()));
    // callback in query string is "1" on Avardas redirect back to the client AFTER purchase.
    if (this.queryStringObject.callback === "1")
    {
      finalizePayment(this.queryStringObject.purchaseId).then(response => {
        if (response && response.status === COMPLETE) {
          const cart = fromJS(response.cart);
          analyticsPurchaseEvent(this.queryStringObject.purchaseId, cart);
          History.push('/tack', {order: response});
        }
        else if (response && response.status === PENDING) {
          this.setState({avardaSessionId: this.queryStringObject.purchaseId, deliveryMethodId: this.queryStringObject.deliveryMethodId, serverSideCallbackUrl: this.queryStringObject.serverSideCallbackUrl});
        }
        else {
          History.push('/error');
        }
        /*
        if (response && response.success) {
          const cart = fromJS(response.cart);
          analyticsPurchaseEvent(this.queryStringObject.purchaseId, cart);

          History.push('/tack', {order: response});
        } else {
          History.push('/error');
        }
        */
      });
    }
    // callback in query string is "2" on Avardas redirect back to the client BEFORE purchase (special case for Safari browser).
    else if (this.queryStringObject.callback === "2")
    {
      this.setState({avardaSessionId: this.queryStringObject.purchaseId, deliveryMethodId: this.queryStringObject.deliveryMethodId});
      this.completeFirstStep(this.queryStringObject.deliveryMethodId);
    }

    if (!this.state.avardaSessionId && !this.state.deliveryMethodId && !this.props.deliveryMethods.isEmpty() && this.queryStringObject.callback !== "1") {
      this.firstStep(this.props.deliveryMethods.first().get('id'))
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (!nextState.avardaSessionId && !nextState.deliveryMethodId && this.props.deliveryMethods.isEmpty() && !nextProps.deliveryMethods.isEmpty() && this.queryStringObject.callback !== "1") {
      this.firstStep(nextProps.deliveryMethods.first().get('id'))
    }
  }

  selectDeliveryMethodHandler(event) {
    const deliveryMethodId = event.target.value;
    this.firstStep(deliveryMethodId);
  }

  firstStep(deliveryMethodId) {
    setDeliveryMethod(deliveryMethodId, this.state.avardaSessionId).then((data) => {
      const success = data === 200;

      this.setState({
        showAvardaError: false,
      });

      if (success) {
        if (window.AvardaCheckOutClient && this.state.avardaSessionId) {
          window.AvardaCheckOutClient.updateItems();
        }

        this.setState({
          deliveryMethodId,
        });

        if (this.state.avardaSessionId === null) {
          this.completeFirstStep(deliveryMethodId);
        }
      } else {
        this.setState({
          showAvardaError: true,
        });
      }

      // fetch updated cart with current delivery cost
      this.props.fetchCart({ endpointUrl: `${CART_API_BASE_URL}/get`, method: 'GET' });
    });
  }

  completeFirstStep() {
    initializePayment().then(response => {
      if (response && response.purchaseId) {
        this.setState({ avardaSessionId: response.purchaseId, serverSideCallbackUrl: response.serverSideCallbackUrl });
      } else {
        console.error('No purchase id in response from server:', response);
      }
    });
  }

  renderInfoLinks() {
    return this.props.currentPage
      .getIn(['fields', 'buyingInfoLinks'], List())
      .map(item => (
        <Box key={item.get('id')} width={[1, 1 / 2]} px="4px">
          <NavigationButton mb={8} url={item.get('url')} title={item.get('name')} bgColor={color.lightGrey} />
        </Box>
      ))
      .toArray();
  }

  renderDeliveryMethods() {
    return this.props.deliveryMethods.map(item => (
      <DeliveryRow
        key={item.get('id')}
        id={item.get('id')}
        title={item.get('name')}
        text={item.get('description')}
        onChange={this.selectDeliveryMethodHandler}
        defaultChecked={this.queryStringObject.deliveryMethodId}
        cost={item.get('id', '').toLowerCase().includes('fri') ? 0 : item.get('cost')}
        activeValue={this.state.deliveryMethodId}
      />
    ))
    .toArray();
  }

  render() {
    const { viewstate, currentPage } = this.props;
    const { avardaSessionId, deliveryMethodId, serverSideCallbackUrl } = this.state;
    const isMobile = viewstate.get('pageWidth') < size.xLarge;
    const infoLinks = this.renderInfoLinks();
    const deliveryMethods = this.renderDeliveryMethods();

    if (!this.props.cart.size && !this.queryStringObject.callback) {
      History.push('/');
    }

    const isWaitingForPaymentToFinalize = (this.queryStringObject.callback === "1" && !(avardaSessionId && deliveryMethodId && serverSideCallbackUrl));

    if (isWaitingForPaymentToFinalize) {
      return (
        <Page title="Vi behandlar din order" noBreadcrumbs bgImg={`${SITE_ROOT_URL}/_images/73fdd938-8f5d-42f4-b26d-ea85ce187812/xander-ashwell-25528-unsplash.jpg`}>
          <Container bgColor="transparent" style={{ paddingTop: '0', paddingBottom: '0', minHeight: '60vh' }}>
            <InnerContainer>
              <WhiteContainer>
                <Heading big margin="0 0 1rem">Vänligen vänta</Heading>
                <Preamble>Vi behandlar din order.</Preamble>
                <LoadingSpinner margin="4rem auto !important" />
              </WhiteContainer>
            </InnerContainer>
          </Container>
        </Page>
      );
    }

    return (
      <Page meta={currentPage.get('metaData')} bgColor={color.white} noBreadcrumbs>
        <Flex flexWrap={isMobile ? 'wrap' : 'nowrap'} style={{ margin: '0 auto' }}>
          <Flex flexWrap={isMobile ? 'wrap' : 'nowrap'} style={{ maxWidth: '750px', margin: '0 auto', width: "100%" }}>
            <Box width={isMobile ? 1 : "100%"} style={{ order: isMobile ? 2 : 1, flex: 1 }}>
              <Container bgColor={color.white} noPadding>
                <ContentContainer>
                  <Heading.h1>{currentPage.getIn(['fields', 'title'])}</Heading.h1>

                  <Conditional show={!!currentPage.getIn(['fields', 'introduction'])}>
                    <Preamble textAlign="left">{currentPage.getIn(['fields', 'introduction'])}</Preamble>
                  </Conditional>

                  <Conditional show={!currentPage.getIn(['fields', 'buyingInfoLinks'], List()).isEmpty()}>
                    <Flex flexWrap="wrap" mx="-4px">
                      {infoLinks}
                    </Flex>
                  </Conditional>


                  <LinedHeading bgColor={color.white}>{currentPage.getIn(['fields', 'titleDeliveries'])}</LinedHeading>
                  {deliveryMethods}

                  <Conditional show={this.state.showAvardaError}>
                    <Paragraph style={{ color: color.warning }}>
                      &#8226; Något gick fel när vi försökte kommunicera med betalleverantören, vänligen försök igen senare.
                    </Paragraph>
                  </Conditional>

                  <LinedHeading bgColor={color.white}>
                    {currentPage.getIn(['fields', 'titleCustomerDetails'])}
                  </LinedHeading>
                  {deliveryMethodId && avardaSessionId ? (
                    <div>
                      <Paragraph>{currentPage.getIn(['fields', 'textCustomerDetails'])}</Paragraph>
                      <CampaignCodeInput avardaSessionId={avardaSessionId} />
                      <AvardaCheckoutForm
                        avardaSessionId={avardaSessionId}
                        deliveryMethodId={deliveryMethodId}
                        serverSideCallbackUrl={serverSideCallbackUrl}
                        cart={this.props.cart}
                      />
                    </div>
                  ) :
                    false
                  }

                </ContentContainer>
              </Container>
            </Box>
            {isMobile &&
              <CartBox width={1} ml={0} style={{ order: 1}}>
                  <Container bgColor={color.lightGrey} noPadding>
                    <CartWrapperCheckoutPage totalCartItems={getTotalCartItems(this.props.cart)} />
                  </Container>
              </CartBox>
            }
          </Flex>
          {!isMobile &&
            <CartBox width="560px" ml={20} style={{ order: 2 }}>
              <Cart onCheckoutPage />
            </CartBox>
          }
        </Flex>
      </Page>
    );
  }
}

const CartBox = styled(Box)`
`;

const ContentContainer = styled.div`
  padding: 42px 0 66px 0;
`;

CheckoutPage.defaultProps = {
  cart: Map(),
  viewstate: Map(),
  currentPage: Map(),
  deliveryMethods: Map(),
};

CheckoutPage.propTypes = {
  cart: PropTypes.instanceOf(Map),
  viewstate: PropTypes.instanceOf(Map),
  currentPage: PropTypes.instanceOf(Map),
  deliveryMethods: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired,
  removeViewstate: PropTypes.func.isRequired,
  fetchArticlePageView: PropTypes.func.isRequired,
  fetchDeliveryMethods: PropTypes.func.isRequired,
  fetchCart: PropTypes.func.isRequired,
};

export default connect(
  CheckoutPage,
  { removeViewstate, fetchArticlePageView, fetchDeliveryMethods, fetchCart },
  (store, props) => ({
    cart: store.cart,
    viewstate: store.viewstate,
    currentPage: store.page.data.get(props.location.pathname),
    deliveryMethods: store.deliveryMethods,
  })
);



// WEBPACK FOOTER //
// ./src/pages/CheckoutPage.js